export default "__VITE_ASSET__Dyxs$fHJ__"